export default ({...props}) => {
  const {palette, size, rem} = props.theme
  return `
  height: ${size(7)}px;
  min-width: 100%;
  max-width:${size(100)}px;
  margin-bottom: ${size(0.625)}px;
  padding: ${size(0)}px;
  .MuiFormControlLabel-root {
    margin: ${size(1)}px;
    width: 100%;
    height:100%;
    margin-right:${size(0)}px;
    margin-left: 0px;
    padding-left: ${size(2)}px;
    .MuiTypography-root {
      width: 100%;
    }
  }
  [ap_atom_name="svgIconAtom"]{
    width: ${size(2.25)}px;
    height:${size(2.375)}px;
    align-items: center;
    display: flex;
    > svg {
      width: ${size(12.5)}%;
    }
  }
  [ap_type="cardCheckSelected"]{
    path {
      fill: ${palette.common.white};
    }
  }
  &[ap_type="secondary"]{
    border-color: ${palette.text.disabled};
    color: ${palette.secondary.light};
  }
  .MuiTypography-body1{
    margin-bottom: ${size(0)}px;
  }

  [ap_atom_name="stackAtom"]{
    width: 100%;
    justify-content: space-between;
    padding-right:${size(3)}px;
    & > div{
      padding: ${size(0)}px;
      padding-left:${size(1)}px;
    }
  }

  [ap_atom_name="typographyAtom"]{
    @media screen and (max-width: 420px) {
      font-size: ${rem(0.93)};
    }

    @media screen and (max-width: 401px) {
      font-size: ${rem(0.86)};
    }
    @media screen and (max-width: 381px) {
      font-size: ${rem(0.8)};
    }
    @media screen and (max-width: 361px) {
      font-size: ${rem(0.7)};
    }
  }
  `
}
